import { render, staticRenderFns } from "./coursemore.vue?vue&type=template&id=031c62fd&scoped=true&"
import script from "./coursemore.vue?vue&type=script&lang=js&"
export * from "./coursemore.vue?vue&type=script&lang=js&"
import style0 from "./coursemore.vue?vue&type=style&index=0&id=031c62fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c62fd",
  null
  
)

export default component.exports